import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// PAGES
import CheckoutPage from './routes/Checkout';
import OrderConfirmationPage from './routes/Confirmation';
import Layout from '../layouts';
import PageNotFound from './routes/PageNotFound';

const AppRouter = () => {
	return (
		<Router>
			<Routes>
				<Route path='/' element={<Layout />}>
					<Route path=':campaignId' element={<CheckoutPage />} />
					<Route path='/' element={<CheckoutPage />} />
					<Route path='/confirmation' element={<OrderConfirmationPage />} />
					<Route path='*' element={<PageNotFound />} />
				</Route>
			</Routes>
		</Router>
	);
};

export default AppRouter;
